import { useMutation, useQueryClient } from 'react-query';
import { axios, createFormData } from '../api/axios';

export default function useDeleteDirectMessage(options) {
  const queryClient = useQueryClient();

  const query = useMutation((data) => {
    return axios.post('/direct/delete_message/', createFormData(data));
  }, options || {});

  const updateQueryData = (response, memberId, messageId) => {
    const { status } = response;

    if (status === 'ok') {
      messageId = parseInt(messageId, 10);
      memberId = parseInt(memberId, 10);

      const queryKey = ['direct/get-messages', memberId];

      const queryData = queryClient.getQueryData(queryKey);

      const { list } = queryData.data;
      const listKeys = Object.keys(list);
      const updatedList = {};

      for (const key of listKeys) {
        updatedList[key] = list[key].filter((message) => {
          if (parseInt(message.id, 10) !== messageId) {
            return message;
          }
        });
      }

      queryData.data.list = updatedList;

      queryClient.setQueryData(queryKey, queryData);
    }
  };

  const mutate = (data, options) => {
    if (options) {
      query.mutate(data, {
        onSuccess: (response, variables, context) => {
          updateQueryData(response.data, data.memberId, data.id);

          if (typeof options.onSuccess === 'function') {
            options.onSuccess(response, variables, context);
          }
        },
        onError: (err, variables, context) => {
          if (typeof options.onError === 'function') {
            options.onError(err, variables, context);
          }
        },
      });
    } else {
      query.mutate(data, {
        onSuccess: (response) => {
          updateQueryData(response.data, data.memberId, data.id);
        },
      });
    }
  };

  return [mutate, query];
}
